<template>
  <div class="h-full d-flex align-center justify-center">
    <div v-if="carregando_dados" class="position-absolute text-center z-1">
      <v-progress-circular color="red" indeterminate size="40" width="3" />
      <p class="ma-0 font-14 mt-2 text-gray-900">Carregando... aguarde</p>
    </div>

    <div class="w-full h-full">
      <apexchart type="area" height="100%" :options="options" :series="series"></apexchart>
    </div>
  </div>
</template>

<script>
import {formatarValorMonetario, logout} from "../../../../helpers/index";
import formatarValoresBi from "../../../../helpers/formatarValoresBi";
import {buscarPerdaDeVendaPorRupturaProdutos} from "@/api/compraPorProdutosGerais/Indicadores";

const dados_default_grafico = {
  referencias: [],
  drp: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  compra: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
};

export default {
  name: "RupturaEstoque",
  data: () => ({
    carregando_dados: true,
    rupturas: Object.assign({}, dados_default_grafico)
  }),
  computed: {
    options() {
      return {
        chart: {
          id: "chart-rupturas",
          type: "area",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          stacked: false,
        },
        grid: {
          show: true,
          position: "back",
          yaxis: {
            lines: {
              show: true
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        noData: {
          text: "Nenhum indicador selecionado",
          align: "center",
          verticalAlign: "middle",
          style: {
            fontSize: "14px"
          }
        },
        stroke: {
          width: 2
        },
        markers: {
          size: 3,
          strokeWidth: 1.2,
          hover: {
            size: 7
          }
        },
        dataLabels: {
          enabled: false
        },
        yaxis: {
          show: true,
          forceNiceScale: true,
          title: {
            text: "Perda de vendas por Rupturas",
            style: {
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title"
            }
          },
          labels: {
            formatter: function(val) {
              return formatarValoresBi(val, 0);
            }
          },
          min: 1,
        },
        xaxis: {
          categories: this.rupturas.referencias,
          labels: {
            minWidth: 50,
            maxWidth: 50,
            style: {
              fontSize: "0.72rem"
            },
            formatter: val => {
              try {
                const [mes_str, ano] = `${val}`.split(' ');
                return `${mes_str.substring(0, 3)}/${ano.substring(2, 4)}`;
              } catch (_) {
                return 'Mês';
              }
            }
          },
          tooltip: {
            enabled: false
          }
        },
        fill: {
          gradient: {
            type: "vertical",
            opacityFrom: 1,
            opacityTo: .8,
            stops: [10, 50, 100]
          }
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: val => {
              return this.rupturas.referencias[val - 1] ? this.rupturas.referencias[val - 1] : 'Mês';
            }
          },
          y: {
            formatter: function(val) {
              return formatarValorMonetario(val);
            }
          }
        },
        legend: {
          show: true,
          position: "top",
          offsetY: 13,
          markers: {
            width: 13,
            height: 13,
            radius: 0
          }
        }
      };
    },
    series() {
      return [
        {
          name: "Rupturas por COMPRA",
          color: "rgba(214, 14, 43, 1)",
          data: this.rupturas.compra
        },
        {
          name: "Rupturas por DRP",
          color: "#FFBF00",
          data: this.rupturas.drp
        }
      ];
    },
    FILTROS_STORE() {
      return this.$store.getters["CompraProdutosGerais/getFiltrosGerais"]
    }
  },
  watch: {
    FILTROS_STORE: {
      handler() {
        this.buscarDadosGrafico();
      },
      deep: true
    }
  },
  created() {
    this.buscarDadosGrafico();
  },
  methods: {
    buscarDadosGrafico() {
      this.carregando_dados = true;
      this.rupturas = Object.assign({}, dados_default_grafico);

      buscarPerdaDeVendaPorRupturaProdutos({filtros: this.FILTROS_STORE})
        .then(this.atualizarGrafico)
        .catch(logout)
    },
    atualizarGrafico(rupturas) {
      this.rupturas = rupturas;
      this.carregando_dados = false;
    }
  }
}
</script>

<style scoped>
</style>
